import { v4 as uuid } from "uuid";
import { generateShareAmountsForSharedCost } from "@/components/pages/dimensions/utils/helpers/shared-cost/generateShareAmountsForSharedCost";
import { DimensionEnhancedSharedCost } from "@/store/dimensions/utils/types/common";

export const generateEmptySharedCost = (
  categoriesIds: string[],
  rulesCount = 0,
): DimensionEnhancedSharedCost => {
  return {
    id: uuid(),
    distribution_type: "manual",
    name: `Allocation Rule ${rulesCount + 1}`,
    share_amounts: generateShareAmountsForSharedCost(categoriesIds),
    filter_tree: { node_type: "group", operator: "and", items: [] },
  };
};
